import {ConfirmDialog, InfoDialog, SelectionDialog} from '@cob/ui-genesis/helpers/cob.dialog.js';

import CustomResource from '@cob/ui-genesis/modules/cob.customResource.js';
import DefinitionM from "./model/recordm.model.entity.definition.js";
import DefinitionSearchResultP from "./presenter/recordm.presenter.searchresult.definition.js";
import InstanceActions from "./actions/recordm.actions.instance.js";
import InstanceCreate from './recordm.instance.create.js';
import RecordmImporterP from "./presenter/recordm.importer.presenter.js";
import SearchVisGroupM from "./model/recordm.model.searchvisgroup.js";
import SimpleSearchM from "./model/recordm.model.simplesearch.js";
import SimpleSearchP from "./presenter/recordm.presenter.simplesearch.js";
import fileUpload from '@cob/ui-genesis/helpers/cob.file-upload.js';

export default function(core){
   return CustomResource(core, {
      dialogs: { ConfirmDialog, InfoDialog, SelectionDialog, fileUpload },
      recordm: {
         DefinitionM: DefinitionM,
         DefinitionSearchResultP: DefinitionSearchResultP,
         InstanceActions: InstanceActions,
         SearchVisGroupM: SearchVisGroupM,
         SimpleSearchM: SimpleSearchM,
         SimpleSearchP: SimpleSearchP,
         RecordmImporterP: RecordmImporterP,
         InstanceCreate: InstanceCreate
      }
   });
}
